import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, BookOpen, Users, Library } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const MobileBottomNav: React.FC = () => {
  const location = useLocation();
  const { t } = useLanguage();
  const isActive = (path: string) => location.pathname === path || (location.pathname.startsWith('/artigo/') && path === '/artigos');

  return (
    <div className="md:hidden fixed bottom-6 left-6 right-6 z-50 bg-[#0a0a0a]/80 backdrop-blur-2xl border border-white/10 rounded-full shadow-[0_10px_40px_rgba(0,0,0,0.8)] pb-[max(env(safe-area-inset-bottom),0px)]">
      <div className="flex justify-around items-center h-16 px-2">
        <Link 
          to="/" 
          aria-label={t('nav.home', 'Início')}
          className={`flex flex-col items-center justify-center w-full h-full space-y-1 transition-all ${
            isActive('/') ? 'text-primary scale-110' : 'text-stone-500 hover:text-stone-300'
          }`}
        >
          <Home size={20} className={isActive('/') ? 'drop-shadow-[0_0_8px_rgba(193,18,31,0.8)]' : ''} />
          <span className="text-[9px] font-medium tracking-wider uppercase">{t('nav.home', 'Início')}</span>
        </Link>
        
        <Link 
          to="/artigos" 
          aria-label={t('nav.articles', 'Artigos')}
          className={`flex flex-col items-center justify-center w-full h-full space-y-1 transition-all ${
            isActive('/artigos') ? 'text-primary scale-110' : 'text-stone-500 hover:text-stone-300'
          }`}
        >
          <BookOpen size={20} className={isActive('/artigos') ? 'drop-shadow-[0_0_8px_rgba(193,18,31,0.8)]' : ''} />
          <span className="text-[9px] font-medium tracking-wider uppercase">{t('nav.articles', 'Artigos')}</span>
        </Link>

        <Link 
          to="/comunidade" 
          aria-label={t('nav.community', 'Comunidade')}
          className={`flex flex-col items-center justify-center w-full h-full space-y-1 transition-all ${
            isActive('/comunidade') ? 'text-primary scale-110' : 'text-stone-500 hover:text-stone-300'
          }`}
        >
          <Users size={20} className={isActive('/comunidade') ? 'drop-shadow-[0_0_8px_rgba(193,18,31,0.8)]' : ''} />
          <span className="text-[9px] font-medium tracking-wider uppercase">{t('nav.community', 'Social')}</span>
        </Link>

        <Link 
          to="/livraria" 
          aria-label={t('nav.bookstore', 'Livraria')}
          className={`flex flex-col items-center justify-center w-full h-full space-y-1 transition-all ${
            isActive('/livraria') ? 'text-primary scale-110' : 'text-stone-500 hover:text-stone-300'
          }`}
        >
          <Library size={20} className={isActive('/livraria') ? 'drop-shadow-[0_0_8px_rgba(193,18,31,0.8)]' : ''} />
          <span className="text-[9px] font-medium tracking-wider uppercase">{t('nav.bookstore', 'Loja')}</span>
        </Link>
      </div>
    </div>
  );
};

export default MobileBottomNav;
